import React from 'react'

function Loader(props) {
  return (
    <div className={props.full ? `fullLoader` : ``}>
        <div className="text-center">
            <div className="lds-roller">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
            </div>
        </div>
    </div>
  )
}

export default Loader